import Colors from '../../../styles/colors';

const styles = {
    title: {
        textAlign: 'center',
        fontSize: '5rem',
        fontWeight: 'bold',
        letterSpacing: '0.00304rem',
        color: Colors.regalBlue,
    },
    description: {
        textAlign: 'center',
        fontSize: '1.6rem',
        fontWeight: '400',
        lineHeight: '2.9rem',
        color: Colors.greyDarker,
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
};

export default styles;
